import reportHandle from './reportHandle'
import agOrderPay from './agOrderPay'
import channelOrderManage from './channelOrderManage'
import upgradeDealWith from './upgradeHandle'
import balanceHandle from './balanceHandle'
import issueInvoiceHandle from './issueInvoiceHandle'
import topUpManage from './topUpManage'

export default [
  {
    path: '/null',
    component: () => import('@/components'),
    children: [
      ...reportHandle,
      ...agOrderPay,
      ...channelOrderManage,
      ...upgradeDealWith,
      ...balanceHandle,
      ...issueInvoiceHandle,
      ...topUpManage
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/handle/index.js